import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { TertiaryHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import RichText from 'components/RichText';
import { IMAGE_RATIOS, IMAGE_WIDTHS, IMAGE_BG_COLOR } from 'constants/images';
import Theme from 'styles/theme';

const InfoCardDesktop = ({ image, heading, subText }) => (
  <div className="InfoCardDesktop" tabIndex="0" role="tab">
    <div className="InfoCardDesktop__image-wrapper">
      <Image
        className="InfoCardDesktop__image"
        src={get(image, 'src')}
        alt={get(image, 'alt')}
        transformations={{ backgroundColor: IMAGE_BG_COLOR }}
        width={IMAGE_WIDTHS.W_1000}
        ratio={IMAGE_RATIOS.R_1x1}
      />
      <div className="InfoCardDesktop__overlay-header">
        <TertiaryHeading className="InfoCardDesktop__overlay-heading">{heading}</TertiaryHeading>
      </div>
    </div>
    <div className="InfoCardDesktop__overlay" />
    <div className="InfoCardDesktop__overlay-subheader">
      <RichText content={subText} />
    </div>
    <div className="InfoCardDesktop__header--fake">
      <TertiaryHeading className="InfoCardDesktop__overlay-heading">{heading}</TertiaryHeading>
    </div>
    <style jsx>{`
      .InfoCardDesktop {
        width: 100%;
        overflow: hidden;
        flex-grow: 1;
        text-decoration: none;
        position: relative;
        background-color: ${Theme.get('colors-white')};
        box-shadow: 0 8px ${Theme.get('spacing') * 4}px 0 rgba(0, 0, 0, 0.12);
      }

      .InfoCardDesktop__image-wrapper {
        width: 100%;
        background-color: ${IMAGE_BG_COLOR};
        position: relative;
      }

      .InfoCardDesktop__overlay {
        position: absolute;
        opacity: 0;
        background-color: ${Theme.get('colors-white')};
        height: 100%;
        width: 100%;
        top: 0;
        transition: all ${Theme.get('transition-duration-ms')}
          ${Theme.get('transition-timing-ease-out-quad')};
      }

      .InfoCardDesktop__overlay-header,
      .InfoCardDesktop__header--fake {
        padding: ${Theme.get('spacing') * 3}px;
      }

      .InfoCardDesktop__overlay-header {
        position: absolute;
        z-index: 1;
        top: 100%;
        bottom: 0;
        transition: all ${Theme.get('transition-duration-ms')}
          ${Theme.get('transition-timing-ease-out-quad')};
        width: 100%;
      }

      .InfoCardDesktop__overlay-subheader {
        position: absolute;
        z-index: 1;
        bottom: 0px;
        padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 3}px 0;
        opacity: 0;
        transition: all ${Theme.get('transition-duration-ms')}
          ${Theme.get('transition-timing-ease-in')};
        width: 100%;
      }

      .InfoCardDesktop__header--fake {
        visibility: hidden;
      }

      .InfoCardDesktop:hover .InfoCardDesktop__overlay-header,
      .InfoCardDesktop:focus .InfoCardDesktop__overlay-header {
        top: 0;
      }

      .InfoCardDesktop:hover .InfoCardDesktop__overlay,
      .InfoCardDesktop:focus .InfoCardDesktop__overlay {
        opacity: 1;
      }

      .InfoCardDesktop:hover .InfoCardDesktop__overlay-subheader,
      .InfoCardDesktop:focus .InfoCardDesktop__overlay-subheader {
        opacity: 1;
        bottom: 12px;
      }
    `}</style>
    <style jsx global>
      {`
        .InfoCardDesktop__overlay-subheader p.Paragraph {
          margin: 0;
        }

        .InfoCardDesktop__overlay-heading.typography--tertiary-heading {
          font-size: 16px;
        }
      `}
    </style>
  </div>
);

InfoCardDesktop.propTypes = {
  image: PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string }).isRequired,
  heading: PropTypes.string.isRequired,
  subText: PropTypes.shape({}).isRequired,
};

export default InfoCardDesktop;
